:host {
  display: inline-flex;
  max-width: 100%;
  width: auto;
  height: auto;
}

gz-complex-enum-filter {
  --dropdown-width: 240px;
}
